import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BundleService {

  private baseUrl = `${environment.Server_URL}/bundles`;

  constructor(private http: HttpClient) { }

  getAll(page?: number, perPage?: number): Observable<any> {

    let params = new HttpParams();

    // ✅ لو page موجود
    if (page) {
      params = params.set("page", page.toString());
    }

    // ✅ لو perPage موجود
    if (perPage) {
      params = params.set("per_page", perPage.toString());
    }

    return this.http.get(this.baseUrl, { params });
  }


  // 🟢 Get single bundle
  getById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  // 🟢 Create bundle
  create(payload: FormData): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  // 🟢 Update bundle
  update(id: number, payload: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/${id}`, payload);
    // لو حابب REST strict خليها PUT
  }

  // 🔴 Delete bundle
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  // 🟢 Get bundles by warehouse (اختياري)
  getByWarehouse(warehouseId: number, page = 1): Observable<any> {
    return this.http.get(
      `${this.baseUrl}?warehouse_id=${warehouseId}&page=${page}`
    );
  }
}
